import Vue from 'vue'
import App from './App.vue'
import {vuex} from '@/vuex.js'
import {mixin} from '@/mixin.js'
import ViewUI from 'view-design';
import 'ant-design-vue/dist/antd.css';
import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/display.css';
import Antd from 'ant-design-vue';
import VueVirtualScroller from 'vue-virtual-scroller'

Vue.use(VueVirtualScroller)
Vue.use(Antd);
Vue.use(ViewUI);

Vue.config.productionTip = false

Vue.prototype.$bus = new Vue();
Vue.mixin(mixin)
new Vue({
    render: h => h(App),
    store: vuex
}).$mount('#app')
